'use strict';

exports.__esModule = true;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _capitalize2 = require('lodash/capitalize');

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DECIMAL_PLACES = 2;
var REVIEWS_TO_SHOW = 5;

var addToSchema = function addToSchema(schema, item) {
    var key = (0, _keys2.default)(item)[0];
    if (!key || !item || !item[key]) return;
    (0, _assign2.default)(schema, item);
};

var getPracticePriceRange = function getPracticePriceRange(practice) {
    var prices = [];

    (0, _get3.default)(practice, 'health_checks', []).forEach(function (treatment) {
        treatment.packages.forEach(function (treatmentKind) {
            treatmentKind.price[0] && prices.push(+treatmentKind.price[0]);
            treatmentKind.price[1] && prices.push(+treatmentKind.price[1]);
        });
    });

    prices.filter(function (item) {
        return item !== 0;
    });

    return prices.length > 0 && '\xA3' + Math.min.apply(Math, prices) + '-\xA3' + Math.max.apply(Math, prices) || 'N/A';
};

var getTreatmentScheme = function getTreatmentScheme(service, treatment) {
    var treatmentType = service.parent_name === 'Scan' ? 'MedicalTest' : 'MedicalProcedure';
    var treatmentImage = (service.icon_uri && service.icon_uri[0] === '/' ? 'https://www.doctify.co.uk' + service.icon_uri : service.icon_uri) || null;

    return {
        '@type': treatmentType,
        'name': treatment.package_name,
        'description': service.description,
        'image': treatmentImage
    };
};

var SchemaPractice = function (_React$Component) {
    (0, _inherits3.default)(SchemaPractice, _React$Component);

    function SchemaPractice(props) {
        (0, _classCallCheck3.default)(this, SchemaPractice);
        return (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
    }

    SchemaPractice.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return !((0, _isEqual3.default)(this.props, nextProps) && (0, _isEqual3.default)(this.state, nextState));
    };

    SchemaPractice.prototype.render = function render() {
        var jsonld = {
            employee: [],
            memberOf: [],
            review: [],
            availableService: [],
            medicalSpecialty: []
        };

        var practiceData = (0, _get3.default)(this.props, 'practiceData', {});
        var reviewData = (0, _get3.default)(this.props, 'reviewData', {});

        var practice = (0, _get3.default)(practiceData, 'practice', {});
        var attributes = (0, _get3.default)(practice, 'attributes', {});
        var uriId = (0, _get3.default)(practice, 'uri_id', null);

        var about = ((0, _get3.default)(attributes, 'about') || '').replace(/<\/?[^>]+(>|$)/g, '').replace(/&rsquo;/g, '’').replace(/&nbsp;/g, ' ');

        jsonld = uriId && (0, _extends3.default)({}, jsonld, {
            '@context': 'http://schema.org',
            '@type': 'MedicalClinic',
            '@id': 'https://www.doctify.co.uk/practice/' + uriId,
            url: 'https://www.doctify.co.uk/practice/' + uriId,
            address: {
                '@type': 'PostalAddress'
            }
        }) || jsonld;

        var name = (0, _get3.default)(practice, 'name', null);
        addToSchema(jsonld, { name: name });

        var telephone = (0, _get3.default)(practice, 'phone', null);
        addToSchema(jsonld, { telephone: telephone });

        var description = about;
        addToSchema(jsonld, { description: description });

        var profileLogo = (0, _get3.default)(attributes, 'profile_logo');
        addToSchema(jsonld, { logo: profileLogo && profileLogo + '_lg.jpg' || null });

        var profileFeaturedImage = (0, _get3.default)(attributes, 'profile_featured_image');
        addToSchema(jsonld, { image: profileFeaturedImage && profileFeaturedImage + '_lg.jpg' || profileLogo && profileLogo + '_lg.jpg' || null });

        var email = (0, _get3.default)(practice, 'email');
        addToSchema(jsonld, { email: email });

        var address = (0, _get3.default)(practice, 'address', {});
        var addressCountry = (0, _get3.default)(address, 'country', null);
        jsonld = addressCountry && (0, _extends3.default)({}, jsonld, {
            address: (0, _extends3.default)({}, jsonld.address, {
                addressCountry: addressCountry
            })
        }) || jsonld;

        var addressLocality = (0, _get3.default)(address, 'city', null);
        jsonld = addressLocality && (0, _extends3.default)({}, jsonld, {
            address: (0, _extends3.default)({}, jsonld.address, {
                addressLocality: addressLocality
            })
        }) || jsonld;

        var postalCode = (0, _get3.default)(address, 'postcode', null);
        jsonld = postalCode && (0, _extends3.default)({}, jsonld, {
            address: (0, _extends3.default)({}, jsonld.address, {
                postalCode: postalCode
            })
        }) || jsonld;

        var streetAddress = (0, _get3.default)(address, 'street1', null);
        jsonld = streetAddress && (0, _extends3.default)({}, jsonld, {
            address: (0, _extends3.default)({}, jsonld.address, {
                streetAddress: streetAddress
            })
        }) || jsonld;

        var specialists = (0, _get3.default)(practiceData, 'specialists', []);
        specialists.forEach(function (specialist) {
            if (specialist.status !== 'approved') return;
            jsonld.employee.push({
                '@type': 'Person',
                'name': (0, _capitalize3.default)(specialist.title) + ' ' + (0, _capitalize3.default)(specialist.firstname) + ' ' + (0, _capitalize3.default)(specialist.lastname),
                'url': 'https://www.doctify.co.uk/specialist/' + specialist.uriId,
                'sameAs': 'https://www.doctify.co.uk/specialist/' + specialist.uriId,
                'image': specialist.profileImage,
                'telephone': specialist.contactPhone
            });
        });

        var insurers = (0, _get3.default)(practice, 'insurers', []);
        insurers.forEach(function (insurer) {
            jsonld.memberOf.push({
                '@type': 'ProgramMembership',
                'name': insurer.name,
                'url': insurer.website,
                'sameAs': insurer.website
            });
        });

        var numberOfReviews = (0, _get3.default)(practice, 'number_of_reviews', null);
        var averageReview = (0, _get3.default)(practice, 'average_review', null);
        jsonld = numberOfReviews && averageReview && (0, _extends3.default)({}, jsonld, {
            aggregateRating: {
                '@type': 'AggregateRating',
                'worstRating': 1,
                'bestRating': 5,
                'ratingValue': +parseFloat(averageReview).toFixed(DECIMAL_PLACES),
                'ratingCount': numberOfReviews
            }
        }) || jsonld;

        var priceRange = getPracticePriceRange(practice);
        addToSchema(jsonld, { priceRange: priceRange });

        var reviews = (0, _get3.default)(reviewData, 'reviews', []).filter(function (review) {
            return review.status === 'approved';
        }).slice(0, REVIEWS_TO_SHOW);
        reviews.forEach(function (review) {
            jsonld.review.push({
                '@type': 'Review',
                'dateCreated': review.reviewDate,
                'reviewBody': review.review,
                'reviewRating': {
                    '@type': 'Rating',
                    'ratingValue': review.numberOfStars,
                    'bestRating': 5,
                    'worstRating': 1
                },
                'itemReviewed': {
                    '@type': 'MedicalClinic',
                    'name': name,
                    'url': 'https://www.doctify.co.uk/practice/' + uriId,
                    'image': profileFeaturedImage && profileFeaturedImage + '_lg.jpg' || profileLogo && profileLogo + '_lg.jpg' || null,
                    'priceRange': priceRange,
                    'telephone': telephone,
                    'address': jsonld.address
                },
                'author': {
                    '@type': 'Person',
                    'name': 'Verified Patient'
                }
            });
        });

        var availableServices = (0, _get3.default)(practice, 'health_checks', []);
        availableServices.forEach(function (service) {
            service.packages.forEach(function (treatment) {
                jsonld.availableService.push(getTreatmentScheme(service, treatment));
            });
        });

        var medicalSpecialties = (0, _get3.default)(practiceData, 'specialties', []);
        medicalSpecialties.forEach(function (specialty) {
            jsonld.medicalSpecialty.push({
                '@type': 'MedicalSpecialty',
                'name': specialty.name,
                'description': specialty.description,
                'image': (specialty.img && specialty.img[0] === '/' ? 'https://www.doctify.co.uk' + specialty.img : specialty.img) || null
            });
        });

        return _react2.default.createElement('script', { defer: true, type: 'application/ld+json', dangerouslySetInnerHTML: { __html: (0, _stringify2.default)((0, _doctifyUtils.sanitize)(jsonld)) } });
    };

    return SchemaPractice;
}(_react2.default.Component);

exports.default = SchemaPractice;


SchemaPractice.displayName = 'SchemaPractice';
SchemaPractice.propTypes = {};

SchemaPractice.defaultProps = {
    renderMode: 'json',
    specialistData: { 'uri_id': null },
    specialistPracticesData: { 'uri_id': null },
    reviewData: { 'aggregate_review': -1 }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-generator/lib/components/schema-practice.js
// module id = 1120
// module chunks = 0